import { render, staticRenderFns } from "./VxBreadcrumbModified.vue?vue&type=template&id=9824561a&"
import script from "./VxBreadcrumbModified.vue?vue&type=script&lang=js&"
export * from "./VxBreadcrumbModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports